namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockReturnOutDtGrid extends Serenity.EntityGrid<IcStockReturnOutRow, any> {
        protected getColumnsKey() { return IcStockReturnOutDtColumns.columnsKey; }
        protected getDialogType() { return IcStockReturnOutDtDialog; }
        protected getEditorType() { return IcStockReturnOutDtEditor; }
        protected getIdProperty() { return IcStockReturnOutDtRow.idProperty; }
        protected getInsertPermission() { return IcStockReturnOutDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockReturnOutDtRow.localTextPrefix; }
        protected getService() { return IcStockReturnOutDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            // Q.first(filters, x => x.field == fld.DocDate).init = w => {

            //     (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

            //     let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
            //     endDate.valueAsDate = new Date(Date.now());
            // };

            // var q = Q.parseQueryString();
            // if (q["SysDocNo"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "SysDocNo");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["SysDocNo"];
            //     };
            // }


            return filters;
        }
        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;
            

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")


            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "Id", title: "ID", cellWidth: 5, halign: 'left' },
                1: { field: "SysDocNo", title: "เลขที่เอกสาร", cellWidth: 30, halign: 'left' },
                2: { field: "LineItemNo", title: "ลำดับ", cellWidth: 30, halign: 'left' },
                3: { field: "SkuCode", title: "รหัสSKU", cellWidth: 30, halign: 'left' },
                4: { field: "ItemRemark", title: "บันทึก", cellWidth: 30, halign: 'left' },
                5: { field: "Qty", title: "จำนวน", cellWidth: 30, halign: 'left' },
                6: { field: "UnitCost", title: "ตุ้นทุนต่อหน่วย", cellWidth: 30, halign: 'left' },
                7: { field: "PurUnit", title: "หน่วย", cellWidth: 30, halign: 'left' },
                8: { field: "PurUnitRatio", title: "จำนวนในหน่วยสต๊อก", cellWidth: 30, halign: 'left' },
                9: { field: "PurUnitPrice", title: "มูลค่าต่อหน่วยสต๊อก", cellWidth: 30, halign: 'left' },
                10: { field: "CostValue", title: "รวมเป็นเงินรวม", cellWidth: 20, halign: 'left' },

            }
            return buttons;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    //new Slick.Aggregators.Sum('UnitCost'),
                    //new Slick.Aggregators.Sum('PurUnitRatio'),
                    //new Slick.Aggregators.Sum('PurUnitPrice'),
                    new Slick.Aggregators.Sum('CostValue')

                ]

            });
            return grid;
        }
    }
}